var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-progress mx-auto"},[_c('div',{staticClass:"d-flex"},_vm._l((_vm.sections),function(ref){
var sectionKey = ref[0];
var section = ref[1];
return _c('bs-tooltip',{key:sectionKey,attrs:{"title":_vm.getTitle(section),"placement":"bottom"}},[_c('SectionRadio',{attrs:{"chapter-display-order":_vm.chapterDisplayOrder,"current-section":_vm.currentSection,"section":section}})],1)}),1),_vm._v(" "),_c('div',[_c('SummaryButton')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }